import { Observable, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';

import { LazyLoadEvent, CheckboxModule } from 'primeng';
import { IPageResult } from '../../interfaces/page-result';
import { IStorageType } from '../../interfaces/storage-type';
import { IStorageTypeFilter } from '../../interfaces/storage-type-filter';
import { StorageTypeService } from '../../services';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'storage-types',
  templateUrl: './manage-storage-type.component.html',
})
export class StorageTypesComponent implements OnInit {
  public page: IPageResult<IStorageType> = {
    items: [],
    total: 0,
  };

  public filter: Subject<IStorageTypeFilter>;
  public filterSto: IStorageTypeFilter;
  public isLoaded: boolean = false;
  public displayDialog: boolean = false;
  public storage: IStorageType;
  public newstorage: boolean = false;
  public filterString: string;
  public newStorageTypeForm: UntypedFormGroup;
  public name: UntypedFormControl;
  public description: UntypedFormControl;
  public isActive: UntypedFormControl;

  constructor(private storageTypeService: StorageTypeService) {}

  ngOnInit() {
    this.filter = new Subject<IStorageTypeFilter>();

    // subscribe to filter changes with a debounce time
    this.filter.pipe(debounceTime(500)).subscribe((f) => {
      this.load(f);
      this.filterSto = f;
    });

    // set default filter
    this.filter.next({ first: 0, rows: 10 });

    // set formGroup instance
    this.name = new UntypedFormControl(
      '',
      Validators.compose([Validators.required, Validators.maxLength(255)]),
    );
    this.description = new UntypedFormControl(
      '',
      Validators.compose([Validators.required, Validators.maxLength(255)]),
    );
    this.isActive = new UntypedFormControl(true, Validators.required);

    this.newStorageTypeForm = new UntypedFormGroup({
      name: this.name,
      description: this.description,
      isActive: this.isActive,
    });
  }

  load(filter: IStorageTypeFilter) {
    this.storageTypeService.getPage(filter).then((result) => {
      this.page.items = result.items;
      this.page.total = result.total;
      this.isLoaded = true;
    });
  }

  showDialogToAdd() {
    this.newstorage = true;
    this.storage = {
      name: '',
      description: '',
      id: 0,
      isActive: true,
    };
    this.resetFormValues(this.storage);
    this.displayDialog = true;
  }

  save(formValues) {
    this.storage.name = formValues.name.trim();
    this.storage.description = formValues.description;
    this.storage.isActive = formValues.isActive;

    if (this.storage.name !== '') {
      this.storageTypeService.create(this.storage).then((res) => this.load(this.filterSto));
    }
    this.displayDialog = false;
  }

  delete() {
    this.storageTypeService.delete(this.storage.id).then((res) => this.load(this.filterSto));
    this.displayDialog = false;
  }

  resetFormValues(formValues) {
    this.newStorageTypeForm.setValue({
      name: formValues.name,
      description: formValues.description,
      isActive: formValues.isActive,
    });
  }

  onRowSelect(event) {
    this.newstorage = false;
    this.storage = this.cloneValet(event.data);
    this.resetFormValues(this.storage);
    this.displayDialog = true;
  }

  cloneValet(c: IStorageType): IStorageType {
    let storage = { id: 0, name: '', description: '', isActive: true };
    for (let prop in c) {
      storage[prop] = c[prop];
    }
    return storage;
  }

  onGridLazyLoad(event: LazyLoadEvent) {
    // map grid lazy load event to filter
    var eventString = JSON.stringify(event);
    if (eventString === this.filterString) return;
    console.log(event);
    this.filter.next(event);
  }
}
